import React, {Component} from "react";
import Header4 from "../../Header/Header4";
import "./index.css";
import {Button, message, Layout, Menu, Tooltip} from "antd";
import {connect} from "react-redux";

import {
    getBTProductName,
    getSiteNames,
    getBTData,
    putDownloadOderRecords
} from "../UserCenter/components/MyOrder/actions";
import {DownloadOutlined} from "@ant-design/icons";

const {Header, Footer, Sider, Content} = Layout;


class TempBaotouData extends Component {
    state = {
        activeKeys: [],
        productTypeNames: {},
        productSiteItems: [],
        defaultSelectKey: null,
        defaultOpenKey: null,
    }
    productTypes = ['陆表类', '植被类', '水体类', '辐射类', '大气类', '几何类']

    componentDidMount() {
        this._getProductNames()
    }

    _getProductNames = async () => {
        let productTN = {};
        const promises = this.productTypes.map(type =>
            getBTProductName(type, '包头').then(data => {
                productTN[type] = data.payload;
            }).catch(error => {
                console.error(`Error fetching product name for ${type}:`, error);
            })
        );
        await Promise.all(promises);
        for (const pro in productTN) {
            if (productTN[pro]) {
                // console.log('进入页面后第一次加载数据:', productTN[pro], {keyPath: [productTN[pro][0], pro]})
                // this.setState({defaultSelectKey:productTN[pro][0]})
                this._getSiteNames({keyPath: [productTN[pro][0], pro]})
                break
            }
        }
        this.setState({productTypeNames: productTN})
    }

    _downloadClicked = (value) => {
        // let downLoadUrl = global.support.fileServer+'/'+ value.url + `?filename=${value.fileName}`
        let downLoadUrl = value.url + `?filename=${value.fileName}`

        putDownloadOderRecords([{
            fileName: value.fileName,
            orderCreationUserId: this.props.user.userId,
            orderDownloadAddr: downLoadUrl,
            resourceType: "样例数据下载"
        }]).then(data => {
                if (data.code === '200') {
                    message.success('下载订单提交成功!')
                //     此处添加下载成功后的逻辑
                }
            }
        )
        console.log('提交数据检查', {
            fileName: value.fileName,
            orderCreationUserId: this.props.user.userId,
            orderDownloadAddr: downLoadUrl,
            resourceType: "样例数据下载"
        });
        // const link = document.createElement('a');
        // link.href = downLoadUrl;
        // link.download = value.fileName; // 设置下载文件的默认名称
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // message.info('数据开始下载!')
    }

    renderSiteDataItem = () => {
        return this.state.productSiteItems.map((value) => {
            return (
                <div className="baotou_data_Item baotou_data_Item_hoverable" key={value.siteName}>
                    <div className="baotou_item_title">
                        <div className="baotou_item_title_icon"></div>
                        {value.siteName}
                    </div>
                    <hr className="hr_line"/>
                    <div className="baotou_item_body">
                        {value.siteData.map((value) => {
                            return (
                                <Tooltip title="点击下载" key={value.id}>
                                    <Button
                                        onClick={() => this._downloadClicked(value)}
                                        type="link">{this._getSiteProductTime(value.startTime, value.endTime)}
                                    </Button>
                                </Tooltip>
                            )
                        })}
                    </div>
                </div>
            )
        })
    }

    renderManuItem = () => {
        const {productTypeNames} = this.state
        return Object.keys(productTypeNames).length !== 0 ? this.productTypes.map((key) => {
            // console.log(productTypeNames, this.productTypes)
            return (
                <Menu.SubMenu key={key} title={key}>
                    {
                        productTypeNames[key].length > 0 ? productTypeNames[key].map((item, index) => {
                            return <Menu.Item key={item}>{item}</Menu.Item>;
                        }) : null
                    }
                </Menu.SubMenu>
            );
        }) : null;
    }

    _getSiteNames = (e) => {
        // console.log(e.key, e.keyPath)
        let sites = []
        let productName = e.keyPath[0], productType = e.keyPath[1]
        getSiteNames(productType, productName, '包头').then(
            async res => {
                console.log('res.data', res);
                let siteNames = res.payload
                const promises = siteNames.map(siteName =>
                    getBTData(productType, productName, '包头', siteName).then(data => {
                        sites.push({siteName: siteName, siteData: data.payload.records});
                    }).catch(error => {
                        console.error(`Error fetching product name for ${siteName}:`, error);
                    })
                );
                await Promise.all(promises);
                console.log('检查站点产品数据:', sites);
                this.setState({productSiteItems: sites})
            }
        )
        // getSiteNames()
    }

    _getSiteProductTime = (startTime, endTime) => {
        const options = {year: 'numeric', month: 'long'};
        let sTime = new Date(startTime), eTime = new Date(endTime);
        let Time1 = new Date(startTime).toLocaleDateString('zh-CN', options),
            Time2 = new Date(endTime).toLocaleDateString('zh-CN', options)
        if (Time1 === Time2) return sTime.toLocaleDateString('zh-CN', {year: 'numeric', month: 'long', day: 'numeric'})
        else return `${Time1}-${Time2}`
    }
    _downloadDataDescription = () => {
        this._downloadClicked({
            fileName: '包头会议共享数据说明文档.7z',
            url: 'https://caplos.aircas.ac.cn/oss/group1/M00/1D/FE/rBIAB2a_iKyAQZpEAM9cb6PhnCY946.zip'
        })
    }

    render() {
        return (
            <div className="baotou_page">
                <Header4/>
                <div className="baotou_main">
                    <Layout className="baotou_layout">
                        <Sider theme="light" className="baotou_sider">
                            <Menu
                                mode="inline"
                                style={{
                                    height: '100%',
                                }}
                                onClick={this._getSiteNames}
                                // defaultOpenKeys={['陆表类']}
                                // defaultSelectedKeys={[this.state.defaultSelectKey]}
                                // defaultSelectedKeys={['土地覆盖']}
                            >
                                {this.renderManuItem()}
                            </Menu>
                        </Sider>
                        <Content className="baotou_content">
                            <Tooltip title="点击下载数据说明文档">
                                <Button className="download_button" onClick={this._downloadDataDescription}
                                        icon={<DownloadOutlined/>}></Button></Tooltip>
                            <div className="baotou_item_box">
                                {this.renderSiteDataItem()}
                            </div>
                        </Content>
                    </Layout>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(),
    user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(TempBaotouData);